import {
  Box,
  Divider,
  SimpleGrid,
  Stack,
  Text,
  Tooltip,
  forwardRef,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { InlineColorBars } from './ColorBars';
import { CurrencyLabel } from './Currency';
import { InvoiceSearchRecord } from 'api/bindings/InvoiceSearchRecord';
import { InvoiceResponse } from 'api/bindings/InvoiceResponse';

export interface InvoiceBarsProps {
  invoice: InvoiceSearchRecord | InvoiceResponse | undefined;
}

const invoiceColors = ['pink.500', 'yellow.200', 'blue.500'];


export const InvoiceBars = forwardRef((props: InvoiceBarsProps, ref) => {
  const { invoice, ...other } = props;

  const data = useMemo(() => {
    const total = parseFloat(invoice?.total || '0');
    const pending = parseFloat(invoice?.pending || '0');
    const commited = parseFloat(invoice?.totalCommitment || '0');

    return {
      total,
      pending,
      commited,
      consumed: (total / (commited || total + pending)) * 100,
      available: Math.max(0, commited - (total + pending)),
    };
  }, [invoice]);

  const SummaryTooltip = () => (
    <Box p={4}>
      <Stack>
        <SimpleGrid columns={2} spacing={2}>
          <Text as="b">Invoiced:</Text>
          <CurrencyLabel value={data.total} />
          <Text as="b">Pending:</Text>
          <CurrencyLabel value={data.pending} />
          <Text as="b">Committed:</Text>
          <CurrencyLabel value={data.commited} />
        </SimpleGrid>
        <Divider />
        <SimpleGrid columns={2} spacing={2}>
          <Text as="b">Consumed:</Text>
          <Text as="i" textAlign={'right'}>
            {data.consumed}%
          </Text>
          <Text as="b">Available:</Text>
          <CurrencyLabel value={data.available} />
        </SimpleGrid>
      </Stack>
    </Box>
  );

  return (
    <Tooltip hasArrow label={<SummaryTooltip />}>
      <InlineColorBars
        colors={invoiceColors}
        values={[invoice?.total, invoice?.pending, invoice?.totalCommitment]}
        ref={ref}
        {...other}
      />
    </Tooltip>
  );
});
